import getConfig from 'next/config';

import base from './base';

const { publicRuntimeConfig: { assetPrefix } } = getConfig();

const TRADINGVIEW_STYLE = {
  bg: '#1d1d1d',
  grid: '#333',
  lineColor: '#28343C',
  short: '#ea0070',
  shortFill: '#ea0070',
  long: '#70a800',
  longFill: '#70a800',
  crosshair: '#626c73',
  cta: '#363D52',
  ctaHighlight: '#414A67',
  alert: '#FFD506',
  category: 'dark',
  textColor: '#999',
  maLine: '#f5bc00',
  ma1: '#ffc200',
  ma2: '#ff00ff',
  ma3: '#cc0066',
};

const tradingViewStyle = TRADINGVIEW_STYLE;

export default {
  ...base,
  mode: 'DARK',
  fiatPriceColor: '#d4d4d4',
  bg: '#1d1d1d',
  boxbg: '#1d1d1d',
  boxheadbg: '#262626',
  tableRowBg: 'rgb(35, 41, 47)',
  border: '#333',
  border1: '#333',
  activeBorder: '#f3ba2f',
  boxShadow: '0 6px 12px rgba(0,0,0,.775)',
  toolTipBoxShadow: '0 0 12px rgba(0,0,0,.175)',
  activeBg: '#1d1d1d',
  dropdownBg: '#fff',
  tabBorderColor: 'transparent',
  tabBg: '#1d1d1d',
  buttonbg: '#1d1d1d',
  buttonbgactive: '#f0b90b',
  buttonbgdisabled: '#ddd',
  chartbuttonbg: '#1d1d1d',
  chartButtonColorActive: '#fff',
  buttonColorActive: '#f5bc00',
  okButtonBg: '#f0b90b',
  cancelButtonBg: '#666',
  up: '#70a800',
  down: '#ea0070',
  shallowDigitOpacity: 0.5,
  highlight: '#f5bc00',
  chartTheme: 'chart-black-bnb',
  depthTheme: 'depth-black-bnb',
  fontColor: '#d4d4d4',
  fontColor1: '#afafaf',
  fontColor2: '#999',
  fontColor3: '#666',
  fontColor4: '#fff',
  fontColor5: '#d4d4d4',
  formsbg: '#262626',
  inputBorder: '#333',
  formsHeaderbg: 'transparent',
  inputBg: '#1d1d1d',
  heading: '#fff',
  tableRowHoverBg: '#262626',
  loadingShadeColor: 'transparent',
  errorInputBg: 'transparent',
  errorInputBorderColor: '#ef4b5a',
  tooltipBg: '#666',
  counterColor: '#f5bc00',
  bnbBurning: '#e8b342',
  bnbBurnClose: '#aaa',
  xfersLogoBoxBg: '#23448E',
  lineColor: '#f0f0f0',
  sectionBorderRadius: '4px',
  sectionBoxShadow: '-4px 4px 10px 0px rgba(0,0,0,0.1)',
  // web2.0 login
  checkBoxBorder: '#848E9C',
  descriptionWord: 'rgb(153, 153, 153)',
  stableCoinBoxBgActive: '#333E47',
  stableCoinBoxBgDeactivate: '#161B20',
  stableCoinBoxBorderActive: '#3B4750',
  stableCoinBoxBorderDeactivate: '#12161A',

  tradingViewStyle,
  tradingViewCssPath: `${assetPrefix}/static/tradingview/themes/tv-dark-theme-v1.min.css`,
  tradingViewClipPath: 'inset(1px 2px 1px 1px)',

  tradingViewOverrides: {
    'volumePaneSize': 'medium', // large, medium, small, tiny
    'paneProperties.background': tradingViewStyle.bg,
    'symbolWatermarkProperties.transparency': 85,
    'scalesProperties.backgroundColor': '#151a1e',
    'scalesProperties.textColor': tradingViewStyle.textColor,

    'paneProperties.vertGridProperties.color': tradingViewStyle.grid,
    'paneProperties.horzGridProperties.color': tradingViewStyle.grid,
    'paneProperties.crossHairProperties.color': tradingViewStyle.crosshair,
    'scalesProperties.lineColor': tradingViewStyle.lineColor,
    'symbolWatermarkProperties.color': 'rgba(0, 0, 0, 0)',

    'mainSeriesProperties.style': 1,

    //  Candles styles
    'mainSeriesProperties.candleStyle.upColor': tradingViewStyle.long,
    'mainSeriesProperties.candleStyle.downColor': tradingViewStyle.short,
    'mainSeriesProperties.candleStyle.drawWick': true,
    'mainSeriesProperties.candleStyle.drawBorder': true,
    'mainSeriesProperties.candleStyle.borderColor': '#C400CB',
    'mainSeriesProperties.candleStyle.borderUpColor': tradingViewStyle.long,
    'mainSeriesProperties.candleStyle.borderDownColor': tradingViewStyle.short,
    'mainSeriesProperties.candleStyle.wickUpColor': tradingViewStyle.long,
    'mainSeriesProperties.candleStyle.wickDownColor': tradingViewStyle.short,

    'study_Overlay@tv-basicstudies.barStyle.upColor': 'blue',
    'study_Overlay@tv-basicstudies.barStyle.downColor': 'blue',

    'study_Overlay@tv-basicstudies.lineStyle.color': 'blue',

    'study_Overlay@tv-basicstudies.areaStyle.color1': 'blue',
    'study_Overlay@tv-basicstudies.areaStyle.color2': 'blue',
    'study_Overlay@tv-basicstudies.areaStyle.linecolor': 'blue',

  },
  emergencyNotice: {
    wrapBg: '#212121',
    boxBg: '#3d3d3d',
    dotColor: '#f5bc00',
    titleColor: '#fff',
    detailLinkColor: '#f5bc00',
  },
  FormRow: {
    MaxQuantityBoxBg: '#f3ba2e',
    MaxQuantityBoxColor: '#333',
    FiatPriceBoxBg: '#1d1d1d',
    FiatPriceBoxColor: 'white',
  },
  // todo: fix colours for dark theme.
  Modal: {
    modalTitleBg: '#fff',
    modalTitleFontColor: '#fff',
    modalBoxBg: '#666',
    okButtonBg: '#f0b90b',
    okButtonColor: '#fff',
    okButtonBorderColor: '#f0b90b',
    cancelButtonBg: '#999',
    cancelButtonColor: '#fff',
    cancelButtonBorderColor: '#999',
  },
  Download: {
    bg: 'transparent',
  },
  miniSymbolsFiatPrice: {
    bg: '#666',
    color: '#fff',
    shadowColor: 'rgba(51,51,51,0.3)',
    linkHoverColor: '#e8b342',
  },
  orderBookTotalBoxBg: '#666',
  balanceTooltipBg: '#666',
};
